import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../../../services/api";
import { deliveryMethodsKeys } from "../queryKeys";
import { GridQueryParams, IListDeliveryMethodsResponse } from "../@types";

const useListDeliveryMethods = (queryParams?: GridQueryParams) => {
  const { data, isPending } = useQuery<IListDeliveryMethodsResponse>({
    queryKey: deliveryMethodsKeys.listWithParams(queryParams),
    queryFn: () =>
      api
        .listActions(queryParams)
        .then((resp: AxiosResponse<IListDeliveryMethodsResponse>) => resp.data)
  });

  return {
    deliveryMethodsList: data?.results ?? [],
    totalResultCount: data?.count || 0,
    isLoadingDeliveryMethodsList: isPending
  };
};

export default useListDeliveryMethods;
